import React, { FC } from 'react'
import { FlexColumn } from '@/atoms/FlexContainers'
import { useTranslate } from '@/utils/translate/translate-client'
import { useGiveawayContext } from '@/views/PreSales/PreSalesGiveawayView/context/GiveawayContext'
import { GResponsiveText, GTitleXS } from '../UI/Typography'
import { GiveawayRulesContent } from './GiveawayRulesContent'

interface GiveawayRulesSectionProps {
  className?: string
}

export const GiveawayRulesSection: FC<GiveawayRulesSectionProps> = ({ className }) => {
  const { t } = useTranslate('tickets')
  const { theatricalSlug } = useGiveawayContext()

  return (
    <FlexColumn className={className}>
      <GResponsiveText
        className="!font-medium"
        color="white"
        MobileTextComponent={GTitleXS}
        DesktopTextComponent={GTitleXS}
      >
        {t('giveawayRules', 'Giveaway Rules')}
      </GResponsiveText>

      <GiveawayRulesContent theatricalSlug={theatricalSlug} />
    </FlexColumn>
  )
}
